import { Observable } from 'rxjs';
import { UrgencyModel } from 'src/app/store/urgency/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractUrgencyService {
  public abstract getAll(): Observable<InteractorResponse<UrgencyModel[]>>;
}
